import Vue from 'vue'
import Vuex from 'vuex'
import data from './modules/data'
import persistedState from 'vuex-persistedstate'
import getters from './getters'
Vue.use(Vuex)

let clientType = [
  {
    name: '医院',
    value: '2',
    moduleInt: 2010100
  },
  {
    name: '药店',
    value: '1',
    moduleInt: 2010200
  },
  {
    name: '连锁总部',
    value: '3',
    moduleInt: 2010300
  },
  {
    name: '配送商',
    value: '4',
    moduleInt: 2010400
  },
  {
    name: '医生',
    value: '5',
    moduleInt: 2010500
  },
  {
    name: '代理商',
    value: '6',
    moduleInt: 2010600
  }
]
let departmentLeaderList = [
  '部门负责人',
  '直属领导',
  '第2级负责人',
  '第3级负责人',
  '第4级负责人',
  '第5级负责人',
  '第6级负责人',
  '第7级负责人',
  '第8级负责人',
  '第9级负责人',
  '第10级负责人',
  '第11级负责人',
  '第12级负责人',
  '第13级负责人',
  '第14级负责人',
  '第15级负责人',
  '第16级负责人',
  '第17级负责人',
  '第18级负责人',
  '第19级负责人',
  '第20级负责人'
]

//我的导出使用数据
let exportTypeList = {
  1: { title: '药店', path: '/masterDataSystem/client-page/1' },
  2: { title: '医院终端', path: '/masterDataSystem/client-page/2' },
  3: { title: '连锁总部', path: '/masterDataSystem/client-page/3' },
  4: { title: '配送商', path: '/masterDataSystem/client-page/4' },
  5: { title: '医生', path: '/masterDataSystem/client-page/5' },
  6: { title: '代理商', path: '/masterDataSystem/client-page/6' },
  7: { title: '销售数据导出', path: '/flowSystem/sales-data' },
  8: {
    title: '终端/商业进货统计',
    path: '/flowSystem/client-purchase-statistics'
  },
  9: { title: '岗位销售统计导出', path: '/flowSystem/job-sales-statistics' },
  10: {
    title: '省份销售统计导出',
    path: '/flowSystem/province-sales-statistics'
  },
  11: {
    title: '产品销售统计导出',
    path: '/flowSystem/goods-sales-statistics'
  },
  12: {
    title: '商业进销存统计导出',
    path: '/flowSystem/business-sales-inventory-statistics'
  },
  13: {
    title: '按导入人查看统计导出',
    path: '/flowSystem/sales-data-importer'
  },
  14: {
    title: '工业发货分析',
    path: '/flowSystem/industrial-delivery-statistics'
  },
  15: { title: '终端进货分析', path: '/flowSystem/client-sales-statistics' },
  16: {
    title: '商业库存分析',
    path: '/flowSystem/inventory-analysis-statistics'
  },
  17: {
    title: '预警/流失客户分析导出',
    path: '/flowSystem/customer-early-warning-statistics'
  },
  18: {
    title: '渠道汇总导出',
    path: '/flowSystem/channel-summary-statistics'
  },
  19: { title: '窜货详细数据导出', path: '/flowSystem/fleeing-goods-detail' },
  20: { title: '窜货分析导出', path: '/flowSystem/fleeing-goods-statistics' },
  21: { title: '退货分析导出', path: '/flowSystem/client-return-statistics' },
  22: {
    title: '进货频次异常导出',
    path: '/flowSystem/frequency-of-purchase-statistics'
  },
  23: {
    title: '部门统计导出',
    path: '/flowSystem/department-sales-statistics/-1'
  },
  24: {
    title: '历史部门统计导出',
    path: '/flowSystem/department-sales-history-statistics/1/-1'
  },
  25: {
    title: '历史岗位统计导出',
    path: '/flowSystem/history-organization-examine-gw'
  },
  26: { title: '历史销售数据导出', path: '/flowSystem/flow-history-import' },
  27: { title: '库存数据导出', path: '/flowSystem/repertory-data' },
  28: { title: '采购数据导出', path: '/flowSystem/purchase-data' },
  29: { title: '维护开发状态模版导出', path: '' },
  31: {
    title: '终端亩产分析导出',
    path: '/flowSystem/per-mu-of-client-statistics'
  },
  32: { title: '活动导出', path: '/behaviorManage/bazaarActivity/list' },
  33: {
    title: '活动全字段导出',
    path: '/behaviorManage/bazaarActivity/list'
  },
  34: { title: '拜访导出', path: '/behaviorManage/visiting/1' },
  35: {
    title: '工作周报导出',
    path: '/behaviorManage/work-report-week/-1/-1/-1'
  },
  36: {
    title: '工作周报批量导出',
    path: '/behaviorManage/week-rests-personnel'
  },
  37: { title: '拜访数据导出', path: '/behaviorManage/dataAnalysis-export' },
  38: { title: '评分建议导出', path: '/behaviorManage/dataAnalysis-export' },
  39: { title: '档案受访导出', path: '/behaviorManage/dataAnalysis-export' },
  40: {
    title: '休眠档案明细导出',
    path: '/behaviorManage/dataAnalysis-export'
  },
  41: {
    title: '工作月报导出',
    path: '/behaviorManage/work-report-month/-1/-1'
  },
  43: { title: '客户数据导出', path: '/behaviorManage/dataAnalysis-export' },
  44: { title: '工作统计导出', path: '/behaviorManage/work-statistics' },
  45: { title: '创建开发计划模版导出', path: '' },
  49: {
    title: '新医院开发导出',
    path: '/behaviorManage/new-hospital/export'
  },
  50: { title: '关键信息传达导出', path: '/behaviorManage/key-info' },
  51: { title: '审批流导出', path: '' },
  52: { title: '待入库-全部数据下载', path: '' },
  53: { title: '拜访\\协访指标导出', path: '/behaviorManage/visit-index/1' },
  54: { title: '医生拜访指标导出', path: '/behaviorManage/visit-index/3' },
  55: { title: '工业发货数据导出', path: '' },
  57: { title: '按部门导出销售指标', path: '' },
  58: { title: '按终端导出销售指标', path: '' },
  60: { title: '统计销售指标详情导出', path: '' },
  61: { title: '绩效考核导出', path: '/behaviorManage/performance-assess/1' },
  68: { title: '调查问卷导出', path: '' },
  71: { title: '原始流向数据导出', path: '' },
  73: { title: '考核数据导出', path: '' },
  74: {
    title: '日常考勤统计导出',
    path: '/behaviorManage/work-attendance/export'
  },
  75: {
    title: '日常考勤详情导出',
    path: '/behaviorManage/work-attendance/export'
  },
  80: { title: '导入目标量', path: '' },
  82: { title: '勤奋榜积分明细导出', path: '' },
  83: { title: '勤奋榜导出', path: '/behaviorManage/diligence' },
  84: { title: '医院上量导出', path: '/behaviorManage/old-hospital-export' },
  85: { title: '医院开发PDF导出', path: '' },
  87: {
    title: '导出医院自报数据',
    path: '/behaviorManage/self-report-list/2'
  },
  88: {
    title: '导出医院自报数据明细',
    path: '/behaviorManage/self-report-list/2'
  },
  90: { title: '业务指导导出', path: '/behaviorManage/business-guidance' },
  91: { title: '病例导出', path: '' },
  101: {
    title: '绩效考核明细导出',
    path: '/behaviorManage/performance-assess/1'
  },
  125: { title: 'aa', path: '/masterDataSystem/client-page/125' }
}

let departmentLeaderMap = []
for (let i = 0; i < departmentLeaderList.length; i++) {
  departmentLeaderMap.push({
    id: i + 1,
    name: departmentLeaderList[i]
  })
}
let templateAttrList = [
  {
    value: '9',
    label: '会议类服务',
    parent: '专项服务报告'
  },
  {
    value: '10',
    label: '市场调研服务',
    parent: '专项服务报告'
  },
  {
    value: '11',
    label: '市场营销策划服务',
    parent: '专项服务报告'
  },
  {
    value: '12',
    label: '业务宣传服务',
    parent: '专项服务报告'
  },
  {
    value: '13',
    label: '其他',
    parent: '专项服务报告'
  },
  {
    value: '5',
    label: '拜访服务',
    parent: '常规报告'
  },
  {
    value: '6',
    label: '信息收集服务',
    parent: '常规报告'
  },
  {
    value: '7',
    label: '小型沟通会',
    parent: '常规报告'
  },
  {
    value: '8',
    label: '其他',
    parent: '常规报告'
  }
]
let templateAttrObj = {
  5: { label: '拜访服务', parent: '常规报告' },
  6: { label: '信息收集服务', parent: '常规报告' },
  7: { label: '小型沟通会', parent: '常规报告' },
  8: { label: '其他', parent: '常规报告' },
  9: { label: '会议类服务', parent: '专项服务报告' },
  10: { label: '市场调研服务', parent: '专项服务报告' },
  11: { label: '市场营销策划服务', parent: '专项服务报告' },
  12: { label: '业务宣传服务', parent: '专项服务报告' },
  13: { label: '其他', parent: '专项服务报告' }
}

//定义二级菜单数据
/*let menuTwoData={
  //主数据二级菜单
  11:'客户档案',
  12:'产品库',
  13:'基础信息',
  14:'批量操作',
  15:'档案关系维护',
  16:'系统设置',
  //辖区管理二级菜单
  21:'部门/岗位',
  22:'辖区关系',
  23:'基础信息',
  24:'指标达成',
  25:'指标分配',
  26:'系统设置',
  //销讯通二级菜单
  31:'拜访活动',
  32:'审批管理',
  33:'工作报告',
  34:'拜访指标',
  35:'自报数据',
  36:'OA办公',
  37:'数据分析',
  38:'处方分析',
  39:'零售分析',
  391:'零售分析',
  392:'绩效考核',
  393:'合规报告',
  394:'系统设置',
  //彩蝶二级菜单
  41:'工业维护',
  42:'渠道发货分析',
  43:'流向导入',
  44:'流向导入(无清洗)',
  45:'上传记录',
  46:'流向清洗-日报',
  47:'流向清洗-月报',
  48:'流向清洗-周报',
  49:'别名库',
  491:'全流向数据',
  492:'原始数据',
  493:'预警统计',
  494:'公司流向统计',
  495:'服务商流向纬度',
  496:'代理商流向纬度',
  497:'商业流向纬度',
  498:'终端流向纬度',
  498:'终端流向纬度',

}*/
let photoInfo = null

export default new Vuex.Store({
  state: {
    first_goods_id:'',//福牌首次进入时使用
    collapsed: false,
    currentMenu: false,
    hideNavbar: false,
    globalLoading: true,
    accountInfo: {},
    subSystemListStore: {},
    clientDetail: {},
    regionList: [],
    departmentList: [],
    funcModuleArray: [],
    quarterDetail: {}, // 岗位详情 岗位编辑页面
    fieldDetail: {}, // 字段详情 字段编辑页面
    departmentManageQuery: {},
    IEVersion: 11, // ie浏览器版本
    exportDoneCount: 0, // 我的下载-已下载完成数
    isShowExportDoneCount: true,
    importDoneCount: 0,
    isShowImportDoneCount: true,
    pendingTableCount: 0, // 流向系统-待处理数据
    jobManageRadioValue: '',
    transferClientId: -1,
    clientTypeList: [],
    clientClassList: [],
    // 导航栏
    mainSelectedKeys: [],
    subSelectedKeys: [],
    subMenuOpenKeys: [],
    clientCustomizationRulesInfo: {}, // 流向规则信息
    crumbs: '',
    isDownloading: false,
    currentDate: 0,
    departmentListWithoutNum: [],
    clientActiveCls: [],
    clientActiveClsList: [],
    clientActiveClsSales: [], //销售指标专用
    PAGE_TITLE: {},
    clientAllFields: [],
    accountFieldTypeArray: [
      '',
      '单选下拉框',
      '单选按钮',
      '多选下拉框',
      '单行文本',
      '多行文本',
      '日期'
    ],
    /**
     * 1-是否筛选
     * 2-字符类型
     * 3-字符长度
     * 4-字段选项
     * 5-日期类型
     */
    accountFieldTypeList: [
      {
        label: '单选下拉框',
        value: '1',
        fieldType: [1, 4]
      },
      {
        label: '单选按钮',
        value: '2',
        fieldType: [1, 4]
      },
      {
        label: '多选下拉框',
        value: '3',
        fieldType: [1, 4]
      },
      {
        label: '单行文本',
        value: '4',
        fieldType: [2, 3]
      },
      {
        label: '多行文本',
        value: '5',
        fieldType: [2, 3]
      },
      {
        label: '日期',
        value: '6',
        fieldType: [5]
      }
    ],
    departmentLeaderList: departmentLeaderList,
    exportTypeList: exportTypeList,
    departmentLeaderMap: departmentLeaderMap,
    doctorLevelType: 1,
    doctorQuestionnaireIsOpen: '', //是否开启医生等级问卷
    pageRouterKey: 'home',
    save_quarter_id: '',
    setLog: -1,
    // 悬浮按钮
    isFloatBtnOpen: false,
    flowSetting10: {}, //待入库审核配置
    flowSetting11: {}, //待入库批量处理配置
    clientFields: {},
    redListMap: {},
    customClientFlowSetting: [], //自定义档案类型流向配置
    titleArr: [
      '',
      '单选下拉框',
      '多选下拉框',
      '单行文本',
      '多行文本',
      '单选按钮',
      '座机电话',
      '',
      '日期',
      '图片',
      '附件',
      '日期区间',
      '地点',
      '当前页面表单',
      '二级页面表单',
      '选择档案',
      '选择联系人',
      '签到签离',
      '涉及产品',
      '选择医生',
      '',
      '',
      '单项选择',
      '多项选择',
      '图片单选',
      '图片多选',
      '',
      'AB选项组',
      '自报数据',
      '数字文本',
      '',
      '',
      '产品数据上报',
      '竞品数据上报',
      '',
      '',
      '',
      '数据上报（新）',
      '视频',
    ],
    titleArrMap: {
      101: '关联预警',
      39: '涉及科室',
      103: '选择讲者',
      102: '关联标签',
      104: '驻店签到',
    },
    attachedList: [],
    hinyeDpList: ['中成药事业部', '化学药事业部', '第三终端事业部'],
    work_config: [],
    isShowFooter: true,
    orderTypeMap: {
      1: '正常',
      3: '样品',
      5: '退货'
      // 6: '退调货',
      // 4: '折让',
      // 2: '冲红',  盘龙的逻辑 saas别改这里
    },
    orderLabelMap: {
      // 1: '待审核', 盘龙的逻辑 saas别改这里
      2: '审核中',
      3: '已完成',
      4: '已拒绝',
      '-1': '待确认'
    },
    orderPayType: {
      1: '现金付款',
      2: '信用付款',
      3: '申请临时信用'
    },
    cloudQuestionnaireArr: [],
    menuList: [],
    subSystemList: [],
    templateAttrList,
    templateAttrObj,
    photoInfo,
    buryingPoint: {}, //埋点数据
    linkJurisdictionVisible: false, //跳转链接增加权限判断
    IndicatorslinkVisible: false, //跳转链接增加权限判断
    customClient: [] //所有自定义档案
  },
  //是否显示横幅
  isBanner: false,
  //基层cls
  basicCls: '',
  mutations: {
    setFirstGoodsID(state, firstGoodsID) {
      state.first_goods_id = firstGoodsID
    },
    setCrumbs(state, crumbs) {
      state.crumbs = crumbs
    },
    setMainSelectedKeys(state, mainSelectedKeys) {
      console.log(mainSelectedKeys,'mainSelectedKeys')
      state.mainSelectedKeys = mainSelectedKeys
    },
    setSubSelectedKeys(state, subSelectedKeys) {
      console.log(subSelectedKeys,'subSelectedKeys')
      state.subSelectedKeys = subSelectedKeys
    },
    setSubMenuOpenKeys(state, subMenuOpenKeys) {
      state.subMenuOpenKeys = subMenuOpenKeys
    },
    setCurrentMenu(state, collapsed) {
      state.currentMenu = collapsed
    },
    setCollapsed(state, collapsed) {
      state.collapsed = collapsed
    },
    setHideNavbar(state, hideNavbar) {
      state.hideNavbar = hideNavbar
    },
    setGlobalLoading(state, globalLoading) {
      state.globalLoading = globalLoading
    },
    SET_ACCOUNT_INFO(state, accountInfo) {
      let tempAccountInfo = accountInfo
      // TODO: 暂时 天地恒一
      // if ('hinye' === tempAccountInfo.companyRow.company_code) {
      //   tempAccountInfo.companyRow.company_code = 'hinye1';
      // }
      // if (!tempAccountInfo.companyRow.statement.is_hrjz) {
      //   tempAccountInfo.companyRow.statement.is_hrjz = 1;
      // }
      state.accountInfo = tempAccountInfo
    },
    SET_SUB_SYSTEM_LIST_STORE(state, subSystemListStore) {
      let tempSubSystemListStore = subSystemListStore
      // TODO: 暂时 天地恒一
      // if ('hinye' === tempAccountInfo.companyRow.company_code) {
      //   tempAccountInfo.companyRow.company_code = 'hinye1';
      // }
      // if (!tempAccountInfo.companyRow.statement.is_hrjz) {
      //   tempAccountInfo.companyRow.statement.is_hrjz = 1;
      // }
      state.subSystemListStore = tempSubSystemListStore
    },
    setClientDetail(state, clientDetail) {
      state.clientDetail = clientDetail
    },
    setRegionList(state, regionList) {
      state.regionList = regionList
    },
    setDepartmentList(state, departmentList) {
      state.departmentList = departmentList
    },
    setQuarterDetail(state, quarterDetail) {
      state.quarterDetail = quarterDetail
    },
    setFieldDetail(state, fieldDetail) {
      state.fieldDetail = fieldDetail
    },
    setDepartmentManageQuery(state, departmentManageQuery) {
      state.departmentManageQuery = departmentManageQuery
    },
    setIEVersion(state, IEVersion) {
      state.IEVersion = IEVersion
    },
    setExportDoneCount(state, exportDoneCount) {
      state.exportDoneCount = Number.parseInt(exportDoneCount)
    },
    setImportDoneCount(state, importDoneCount) {
      state.importDoneCount = Number.parseInt(importDoneCount)
    },
    setPendingTableCount(state, pendingTableCount) {
      state.pendingTableCount = Number.parseInt(pendingTableCount)
    },
    setIsShowExportDoneCount(state, isShowExportDoneCount) {
      state.isShowExportDoneCount = isShowExportDoneCount
    },
    setIsShowImportDoneCount(state, isShowImportDoneCount) {
      state.isShowImportDoneCount = isShowImportDoneCount
    },
    setFuncModuleArray(state, funcModuleArray) {
      state.funcModuleArray = funcModuleArray
      let clientTypeList = []
      for (let item of clientType) {
        if (funcModuleArray.indexOf(item.moduleInt) > -1) {
          clientTypeList.push(item)
        }
      }
      state.clientTypeList = clientTypeList
    },
    setModuleRow(state, moduleRow) {
      state.moduleRow = moduleRow

      let linkJurisdictionVisible = false
      console.log(state.accountInfo.quarterRow)
      if (state.accountInfo.quarterRow) {
        if (state.accountInfo.quarterRow.is_admin == 1) {
          return
        }
      }

      if (!moduleRow) {
        return
      }

      //不需要判断的module_int
      let filter_module_int = [4010100, 4010300, 4010400]
      if (filter_module_int.indexOf(moduleRow.module_int) > -1) {
        return
      }
      //判断当前url是否有权限
      if (
        moduleRow &&
        moduleRow.module_int &&
        state.funcModuleArray.indexOf(moduleRow.module_int) === -1
      ) {
        linkJurisdictionVisible = true
      }
      state.linkJurisdictionVisible = linkJurisdictionVisible
    },
    setJobManageRadioValue(state, jobManageRadioValue) {
      state.jobManageRadioValue = jobManageRadioValue
    },
    setTransferClientId(state, transferClientId) {
      state.transferClientId = transferClientId
    },
    setClientClassList(state, clientClassList) {
      for (let item of clientClassList) {
        item.value = item.value + ''
      }
      state.clientClassList = clientClassList
    },
    setClientCustomizationRulesInfo(state, clientCustomizationRulesInfo) {
      state.clientCustomizationRulesInfo = clientCustomizationRulesInfo
    },
    setIsDownloading(state, isDownloading) {
      state.isDownloading = isDownloading
    },
    setCurrentDate(state, currentDate) {
      state.currentDate = currentDate
    },
    setDepartmentListWithoutNum(state, departmentListWithoutNum) {
      state.departmentListWithoutNum = departmentListWithoutNum
    },
    save_quarter_id(state, save_quarter_id) {
      state.save_quarter_id = save_quarter_id
    },
    setDoctorLevelType(state, doctorLevelType) {
      state.doctorLevelType = doctorLevelType
    },
    setDoctorLevelQuestionnaireIsOpen(state, isOpen) {
      state.doctorQuestionnaireIsOpen = isOpen
    },
    setClientActiveCls(state, clientActiveCls) {
      let clientActiveClsList = []
      let permissionsList = []
      let PAGE_TITLE = {}
      for (let item of clientActiveCls) {
        //获取基层cls
        if (item.client_name == '基层') {
          state.basicCls = item.id
        }
        clientActiveClsList[item.id] = item.custom_client_name
          ? item.custom_client_name
          : item.client_name
        item.client_name = item.custom_client_name
          ? item.custom_client_name
          : item.client_name
        permissionsList[item.id] = item
        // if (item.id === 1) {
        //   let obj = {
        //     import: 2020104,
        //     editor: 2020105,
        //     del: 2020106,
        //     field: 2030302
        //   };
        //   permissionsList[item.id]['permissions'] = obj;
        // } else if (item.id === 2) {
        //   let obj = {
        //     import: 2020102,
        //     editor: 2020103,
        //     del: 2020101,
        //     field: 2030301
        //   };
        //   permissionsList[item.id]['permissions'] = obj;
        // } else if (item.id === 3) {
        //   let obj = {
        //     import: 2020107,
        //     editor: 2020108,
        //     del: 2020109,
        //     field: 2030303
        //   };
        //   permissionsList[item.id]['permissions'] = obj;
        // } else if (item.id === 4) {
        //   let obj = {
        //     import: 2020110,
        //     editor: 2020111,
        //     del: 2020112,
        //     field: 2030304
        //   };
        //   permissionsList[item.id]['permissions'] = obj;
        // } else if (item.id === 5) {
        //   let obj = {
        //     import: 2020113,
        //     editor: 2020114,
        //     del: 2020115,
        //     field: 2030404
        //   };
        //   permissionsList[item.id]['permissions'] = obj;
        // } else if (item.id === 6) {
        //   let obj = {
        //     import: 2020117,
        //     editor: 2020118,
        //     del: 2020119,
        //     field: 2030305
        //   };
        //   permissionsList[item.id]['permissions'] = obj;
        // }
        var clientName = item.custom_client_name
          ? item.custom_client_name
          : item.client_name

        switch (item.id) {
          case 1:
            PAGE_TITLE[item.id] = {
              page: clientName,
              detail: clientName + '详情',
              add: '添加' + clientName,
              edit: '编辑' + clientName
            }
            break
          case 2:
            PAGE_TITLE[item.id] = {
              page: clientName,
              detail: clientName + '详情',
              add: '添加' + clientName,
              edit: '编辑' + clientName
            }
            break
          default:
            PAGE_TITLE[item.id] = {
              page: clientName,
              detail: clientName + '详情',
              add: '添加' + clientName,
              edit: '编辑' + clientName
            }
            break
        }
      }
      state.clientActiveClsList = clientActiveClsList
      state.permissionsList = permissionsList
      state.clientActiveCls = clientActiveCls.filter((item) => item.id != 10000)
      state.PAGE_TITLE = PAGE_TITLE
    },

    setNowPeriod(state, data) {
      if (data != 1) {
        let tips = ''
        if (data.type == 1) {
          tips = `本次为${data.year}年Q${data.month}季度初始指标，`
        } else {
          tips = `本次为${data.year}年${data.month}月初始指标，`
        }
        if (
          window.location.href.indexOf(
            'jurisdictionSystem/new-saleindex/import-indicators'
          ) > -1
        ) {
          if (tips == '') {
            state.IndicatorslinkVisible = true
          } else {
            state.IndicatorslinkVisible = false
          }
        }
      } else {
        if (
          window.location.href.indexOf(
            'jurisdictionSystem/new-saleindex/import-indicators'
          ) > -1
        ) {
          state.IndicatorslinkVisible = true
        }
      }
    },

    /*销售指标专用*/
    setClientActiveClsSales(state, e) {
      state.clientActiveClsSales = e
    },
    setClientAllFields(state, clientAllFields) {
      state.clientAllFields = clientAllFields
    },
    setPageRouterKey(state, pageRouterKey) {
      state.pageRouterKey = pageRouterKey
    },
    setLog(state, setLog) {
      state.setLog = setLog
    },
    setFloatBtnStatus(state, isFloatBtnOpen) {
      state.isFloatBtnOpen = isFloatBtnOpen
    },
    setFlowSetting10(state, flowSetting10) {
      state.flowSetting10 = flowSetting10
    },
    setFlowSetting11(state, flowSetting11) {
      state.flowSetting11 = flowSetting11
    },
    setClientFields(state, clientFields) {
      state.clientFields = clientFields
    },
    setRedList(state, redList) {
      let redListMap = {}
      for (let item of redList) {
        redListMap[item.int] = item.count
      }
      state.redListMap = redListMap
    },
    setAttachedList(state, attachedList) {
      state.attachedList = attachedList
    },
    set_work_config(state, work_config) {
      state.work_config = work_config
    },
    set_show_footer(state, isShowFooter) {
      state.isShowFooter = isShowFooter
    },
    setCloudQuestionnaire(state, cloudQuestionnaireArr) {
      state.cloudQuestionnaireArr = cloudQuestionnaireArr
    },
    setMenuList(state, menuList) {
      state.menuList = menuList
    },
    setSubSystemList(state, subSystemList) {
      var buryingPoint = {}
      recursion(subSystemList, [], buryingPoint)

      //生成埋点数据
      function recursion(data, arr, newObj) {
        if (data.length) {
          data.forEach((item) => {
            if (item.module_int != '/home') {
              let currentArr = JSON.parse(JSON.stringify(arr))

              currentArr.push(item.module_name)
              newObj[item.module_int - 0] = currentArr
              if (item.menuList && item.menuList.length) {
                recursion(item.menuList, currentArr, newObj)
              }
              if (item.subMenuList && item.subMenuList.length) {
                recursion(item.subMenuList, currentArr, newObj)
              }
            }
          })
        }
      }

      state.buryingPoint = buryingPoint
      state.subSystemList = subSystemList
    },
    setCustomClientFlowSetting(state, CustomClientFlowSetting) {
      let arr = []
      let customClient = []
      delete CustomClientFlowSetting[10000]
      for (let i in CustomClientFlowSetting) {
        let client_name = CustomClientFlowSetting[i].custom_client_name
          ? CustomClientFlowSetting[i].custom_client_name
          : CustomClientFlowSetting[i].client_name
        if (CustomClientFlowSetting[i].is_setting == 1) {
          arr.push({
            value: i,
            name: client_name
          })
        }
        customClient.push({
          id: i - 0,
          name: client_name
        })
        state.customClientFlowSetting = arr
      }
      state.customClient = customClient
      // console.log(CustomClientFlowSetting,11111111111)
    },
    setPhotoInfo(state, photoInfo) {
      state.photoInfo = photoInfo
    },
    setIsBanner(state, isBanner) {
      state.isBanner = isBanner
    }
  },
  actions: {},
  modules: { data },
  getters,
  plugins: [
    persistedState({
      //配置使用浏览器缓存方式
      storage: window.localStorage,
      paths: ['data'] //需要持久化的模块化vuex
    })
  ]
})
